const PromoFooter = ({ links }) => (
  <footer className="u-space-pt-5 u-text-link-inherit-color bg-transparent text-inherit">
    <div className="container u-space-pb-30 u-space-pt-10">
      <ul className="List List--inline List--separator u-space-mb-30 group-with-promoDarkTheme:text-white">
        {links.map((link, index) => (
          <li key={index}>
            <a href={link.url} title="">
              {link.title}
            </a>
          </li>
        ))}
      </ul>

      <div className="my-10">&nbsp;</div>
    </div>
  </footer>
);

export default PromoFooter;
